import Cookies from "js-cookie";
import { logoutSession } from "./authSession";

export function getAuthToken(key) {
  return Cookies.get(key);
}

export function getUser(key) {
  return localStorage.getItem(key);
}

export function logoutUser() {
  return logoutSession();
}
